export interface ContentSearch {
  search_time?: number;
  processing_time?: number;
  translation_time?: number;
  translated_query?: string;
  results_summary?: string | null;
  search_results?: ContentSearchResultEntry[] | null;
  next_page_token?: string;
  total_size?: number;
}

export interface ContentSearchResultEntry {
  category: ContentCategory;
  thumbnail_image: string;
  title: string;
  link: string;
  html_title: string;
  display_link: string;
  snippets?: string[] | null;
}

export enum ContentCategory {
  Article = 'Articles',
  Offers = 'Offers',
}
